import React from 'react';

const UploadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="55"
    viewBox="0 0 60 55"
  >
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <path
            fill="#EAEFFF"
            d="M23.726 45.848L37.021 46.189 36.935 27.859 48.391 27.549 30.074 2.106 11.075 26.49 22.153 26.49z"
            transform="translate(-2926 -261) translate(2926 261)"
          />
          <g fill="#285AFF">
            <path
              d="M36.774 46.892h-14.09c-.465 0-.774-.314-.774-.787V27.374H9.447c-.308 0-.54-.157-.695-.474-.154-.237-.079-.63.079-.867L29.114.295c.308-.393.928-.393 1.24 0l20.208 25.662c.154.157.232.393.232.63 0 .474-.308.787-.774.787H37.55v18.734c0 .47-.387.784-.774.784zM23.46 45.318h12.466V26.587c0-.474.308-.788.774-.788h11.692L29.731 2.106l-18.66 23.693h11.693c.465 0 .774.314.774.788v18.73h-.08z"
              transform="translate(-2926 -261) translate(2926 261)"
            />
            <path
              d="M59.226 55H.774C.308 55 0 54.686 0 54.213V44.137c0-.474.308-.787.774-.787s.774.313.774.787v9.289h56.904v-9.289c0-.474.308-.787.774-.787s.774.313.774.787v10.076c0 .393-.387.787-.774.787z"
              transform="translate(-2926 -261) translate(2926 261)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default UploadIcon;
